import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { setConfirm } from "store/actions/appAction";
import ArrowBackIcon from "assets/icons/ArrowBackIcon";
import PlusIcon from "assets/icons/PlusIcon";
import BasicButton from "components/BasicInputs/BasicButton";
import FactorForm from "components/Factor2/FactorForm";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function FactorPage() {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [tabs, setTabs] = useState<FactorTabType[]>([{ label: "فرم جدید" }]);
  const [active, setActive] = useState(0);
  const [preActive, setPreActive] = useState(0); // usage is for providing exit animation

  function handleActive(index: number) {
    setPreActive(index);
    setTimeout(() => setActive(index), 300);
  }

  function handleDelete(index: number) {
    const newTabs = tabs.map((x, i) => (index === i ? { ...x, deleted: true } : x));
    setTabs(newTabs);
    if (active === index) handleActive(newTabs.findIndex((x) => !x.deleted));
  }

  return (
    <div className="relative w-full h-full">
      <div
        className="bg-white w-full md:h-14 p-2 md:px-10 flex flex-wrap md:flex-nowrap 
                  gap-y-3 items-center justify-between sticky top-16 z-[3] left-0 shadow-proportional
                  border-t-2 sm:flex-nowrap sm:flex xs:flex xs:flex-nowrap "
      >
        <div className="flex items-center w-full md:max-w-[calc(100%_-_110px)] flex-wrap md:flex-nowrap gap-y-3    sm:flex-nowrap  xs:flex  xs:flex-nowrap">
          <IconButton
            className="min-w-[40px] h-10 flex items-center justify-center mx-2"
            style={{ transform: "rotateY(3.142rad)" }}
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon />
          </IconButton>
          <div className="flex items-center overflow-x-auto overflow-y-hidden w-full md:max-w-[calc(100%_-_110px)]">
            {tabs.map((tab, i) => {
              if (tab.deleted) return <></>;
              let label = tab.label;
              if (tab.data && tab.data.title) {
                label = tab.data.title;
              }
              return (
                <div
                  key={i}
                  className={`px-1 pr-3 max-w-[288px] min-w-[150px] md:h-8 relative
                              flex items-center justify-between border-r-2 cursor-pointer transition-all`}
                  onClick={() => handleActive(i)}
                >
                  <span>{label}</span>
                  <IconButton
                    size="small"
                    disableFocusRipple
                    disableTouchRipple
                    onClick={(e) => {
                      e.stopPropagation();
                      const action: any = () => handleDelete(i);
                      dispatch(setConfirm("آیا مطمئن هستید ؟", action));
                    }}
                  >
                    <Close style={{ transform: "scale(0.6)" }} />
                  </IconButton>
                  <div
                    className={`
                    w-[90%] h-0.5 bg-blue-1 rounded-t-sm absolute bottom-0 left-0 animate-fade-in
                    mx-[5%]
                    ${i === preActive ? "" : "hidden"}
                    `}
                  />
                </div>
              );
            })}
          </div>
        </div>

        <div className="min-w-[110px]  ">
          <BasicButton
            onClick={() => {
              const newTabs = [...tabs, { label: "فرم جدید" }];
              setTabs(newTabs);
              handleActive(newTabs.length - 1);
            }}
          >
            <PlusIcon scale={0.7} />
            <span>فرم جدید</span>
          </BasicButton>
        </div>
      </div>

      {tabs.map((tab, i, a) => {
        if (tab.deleted) return <></>;
        return (
          <div
            key={i}
            className={`my-6 
            ${i === preActive ? "animate-fade-in" : "animate-fade-out"} 
            ${i === active ? "" : "hidden"}
            `}
          >
            <FactorForm
              onChange={(data) => setTabs((x) => x.map((y, j) => (i === j ? { ...y, data } : y)))}
              noHeader
              onSuccess={i === a.length - 1 ? undefined : () => handleDelete(i)}
            />
          </div>
        );
      })}
    </div>
  );
}
